import { assertValidVersion } from "@tsparticles/engine";
import { CircleDrawer } from "./CircleDrawer.js";
export async function loadCircleShape(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addShape(new CircleDrawer(), refresh);
}
